import React from "react";
import Navbar from "../../../Components/Widget/Navbar";
import MobileDrawer from "../../../Components/Widget/MobileDrawer";
import Product from "../../../Components/Widget/Product";
import RecentlyViewed from "../../../Components/Widget/RecentlyViewed";
import Footer from "../../../Components/Widget/Footer";
import Scroll from "../widgets/scroll";
// import Popup from "../widgets/popup";

const ExportDefault = (props) => {
  return (
    <>
      <div className="page-wrapper">
        <Navbar {...props} />
        <main className="main">
          <Product {...props} />
          <RecentlyViewed {...props} />
        </main>
        <Footer {...props} />
      </div>
      <Scroll {...props} />
      <MobileDrawer {...props} />
      {/* <Popup {...props} /> */}
    </>
  );
};

export default ExportDefault;
